module.exports = __webpack_public_path__ + "img/introducePageFive_show_two.69096a20.jpg";